import React from "react";
import { CustomFeatureRequestFooter } from "features/ManageOfferings/modules/CustomFeatureRequestFooter/CustomFeatureRequestFooter";
import { PAGE_SECTIONS_KEYS } from "features/ManageOfferings/modules/OfferingPageSections/constants/OfferingPageSectionsKeys.constants";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { KRA_DOCUMENTS_REQUIRED_COUNT } from "./constants/KRAContractFooter.constants";

export const KRAContractFooter = () => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig =
    sectionConfig[PAGE_SECTIONS_KEYS.KRA_CONTRACT_URL] || {};
  const isValuePresent =
    subSectionConfig?.value &&
    subSectionConfig?.value.length == KRA_DOCUMENTS_REQUIRED_COUNT;

  if (!isValuePresent) return <></>;

  return (
    <CustomFeatureRequestFooter
      config={{ key: PAGE_SECTIONS_KEYS.KRA_CONTRACT_URL }}
    />
  );
};
